import React from 'react';
import ReactDOM from 'react-dom/client';
import { configure } from 'mobx';
import { StoreProvider } from './contexts/StoreContext';
import App from './App';
import './styles/variables.css'; // CSS переменные
import './styles/base.css'; // Базовые стили и reset
import './styles/buttons.css'; // Единые стили кнопок
// import './index.css'; // Отключено для отладки

// Настройка MobX
configure({
  enforceActions: 'always', // Строгий режим - изменения только через actions
  computedRequiresReaction: false,
  reactionRequiresObservable: false,
  observableRequiresReaction: false,
  disableErrorBoundaries: false
});

// Импортируем rootStore для инициализации
import { rootStore } from '../stores/index';

// Инициализация приложения
const initApp = async () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  // Показываем загрузку
  root.render(
    <div /* style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }} */>
      <div>
        <div>Инициализация приложения...</div>
        <div /* style={{ marginTop: '10px', fontSize: '14px', opacity: 0.7 }} */>
          Загрузка моделей данных
        </div>
      </div>
    </div>
  );
  
  try {
    // Ждём полной инициализации (модели, сессия, WebSocket)
    await rootStore.initialize();
    
    // Теперь рендерим приложение с готовыми моделями
    root.render(
      <StoreProvider>
        <App />
      </StoreProvider>
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    root.render(
      <div /* style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: 'red'
      }} */>
        <div>
          <div>Ошибка инициализации приложения</div>
          <div /* style={{ marginTop: '10px', fontSize: '14px' }} */>
            {error.message}
          </div>
        </div>
      </div>
    );
  }
};

// Запускаем инициализацию
initApp();